/*
 * Rows added on the front end are given a temporary key so that they can be referenced before they are saved, for
 * example when a newly added rent control is selected on an allowed increases row. The api recognizes that the key
 * does not belong to an existing record and creates one, then returns the saved key.
 *
 * Keys assigned by the api are guids, so they can never collide with the temporary prefix.
 */
const temporaryKeyPrefix = "new-";

let temporaryKeyCount = 0;

const nextTemporaryKey = function (): string {
  temporaryKeyCount = temporaryKeyCount + 1;

  return `${temporaryKeyPrefix}${temporaryKeyCount}`;
};

const isUnsaved = function (key: string | null | undefined): boolean {
  return !key || key.startsWith(temporaryKeyPrefix);
};

const newRowUtils = { nextTemporaryKey, isUnsaved };
export default newRowUtils;
